class SourceReference {
    constructor() {
        const elements = [...document.querySelectorAll('.rich-text div.source-reference')];
        let counter = 0;

        elements.forEach((el) => {
            this.moveElementToPreviousSiblingParagraph(el);
            this.setCounter(el, ++counter);
            this.addEventListeners();
        });
    }

    addEventListeners() {
        [...document.querySelectorAll('.source-reference__close')].forEach((el) => {
            el.addEventListener('click', () => {
                document.activeElement.blur();
            });
        });
    }

    setCounter(el, counter) {
        const counterElement = el.querySelector('.source-reference__counter');
        if (counterElement) {
            counterElement.innerHTML = `[${counter}]`;
        }
    }

    moveElementToPreviousSiblingParagraph(el) {
        if (el.previousElementSibling && el.previousElementSibling.nodeName === 'P') {
            el.previousElementSibling.appendChild(el);
        }
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new SourceReference();
});